import { render, staticRenderFns } from "./VettingEditShortlist.vue?vue&type=template&id=92976934"
import script from "./VettingEditShortlist.vue?vue&type=script&lang=js"
export * from "./VettingEditShortlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports